var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"monaco-editor",staticClass:"editor"},[(!_vm.editor)?_c('div',{staticClass:"spinner"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"100","color":"primary"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }